"use strict";
var Observable_1 = require('../../Observable');
var partition_1 = require('../../operator/partition');
Observable_1.Observable.prototype.partition = partition_1.partition;
//# sourceMappingURL=partition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/partition.js
// module id = 648
// module chunks = 3